import { toast } from 'sonner';

export const onApiError = (message: string) => {
	if (import.meta.env.VITE_PRODUCTION === 'false') {
		toast.error('API error', { important: true, description: message || 'Unknown', duration: 5000 });
	}
};
